import { z } from 'zod';
import { CalendarDay } from '../../../utils';
import { withPaginationParams } from '../../helpers';

export const List = withPaginationParams(
  z.object({
    search: z.string().optional().nullable(),
    reportDate: z.instanceof(CalendarDay).optional().nullable(),
  }),
  ['reportDate'],
);
